import GET_CUSTOMIZED_PLANS from './GetCustomizedPlans.graphql'
import GET_CUSTOMIZED_PLANS_LIST from './GetCustomizedPlansList.graphql'
import GET_FAV_LIST from './GetFavList.graphql'

import GET_TRIPS from './GetTrips.graphql'
import UPDATE_CUSTOMIZED_PLAN from './UpdateCustomizedPlan.graphql'
import UPDATE_ITINERARY_DAY from './UpdateItineraryDay.graphql'
import UPDATE_TRIP_DETAILS from './UpdateTripDetails.graphql'
import LOAD_USER_PROFILE_BY_EMAIL from './LoadUserProfileByEmail.graphql'
import LOAD_USER_PROFILE_BY_PHONE from './LoadUserProfileByPhone.graphql'

export {
  GET_CUSTOMIZED_PLANS,
  GET_CUSTOMIZED_PLANS_LIST,
  GET_FAV_LIST,
  GET_TRIPS,
  UPDATE_CUSTOMIZED_PLAN,
  UPDATE_ITINERARY_DAY,
  UPDATE_TRIP_DETAILS,
  LOAD_USER_PROFILE_BY_EMAIL,
  LOAD_USER_PROFILE_BY_PHONE
}



// WEBPACK FOOTER //
// src/graphql/MyTrips/index.js